import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  subscribeTokenToTopic,
  unsubscribeTokenFromTopic,
} from "@/lib/useFirebaseNotifications";
import { useEffect, useState } from "react";
import { useLocalStorage } from "usehooks-ts";
import { CredenzaContent, CredenzaHeader, CredenzaTitle } from "../ui/credenza";
import { ScrollArea } from "../ui/scroll-area";
import { Switch } from "../ui/switch";
import { useTranslations } from "next-intl";
import { post } from "../../api/public.client";
export default function NotificationTopicsCredenzaContent({
  open,
  setOpen,
}: any) {
  const t = useTranslations("Notifications");
  const [topics, setTopics] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [enabledNotificationTopics, setEnabledNotificationTopics] =
    useLocalStorage("enabled-notification-topics", [] as string[]);
  const [disabledNotificationTopics, setDisabledNotificationTopics] =
    useLocalStorage("disabled-notification-topics", [] as string[]);

  useEffect(() => {
    setLoading(true);
    post("/public/notifications/get-topic-name", {
      body: {
        topics: [...enabledNotificationTopics, ...disabledNotificationTopics],
      },
    }).then((fetchResponse: any) => {
      if (!fetchResponse.error) {
        setTopics(fetchResponse.data);
      }
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <CredenzaContent className="md:max-w-2xl">
      <CredenzaHeader>
        <CredenzaTitle>{t("manage-title")}</CredenzaTitle>
      </CredenzaHeader>
      <ScrollArea className="py-5 h-50">
        <Table>
          <TableCaption>
            {t("manage-description")}
          </TableCaption>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[150px]">{t('event')}</TableHead>
              <TableHead className="w-[100px] text-right">{t('un-subscribe')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody className="overflow-y-scroll h-max-1/2">
            {!loading &&
              topics.length > 0 &&
              topics.map(
                (topic: any, idx: any) =>
                  topic && (
                    <TableRow key={idx}>
                      <TableCell className="capitalize">
                        {`${topic.name} ${topic.filterElement ?? ""} ${
                          topic.filterCondition ?? ""
                        }`}
                      </TableCell>
                      <TableCell className="font-medium text-right">
                        <Switch
                          checked={enabledNotificationTopics.includes(
                            topic.unparsedName,
                          )}
                          onCheckedChange={async (checked) => {
                            if (!checked) {
                              const updatedEnabledNotificationTopics =
                                enabledNotificationTopics.filter(
                                  (storedTopic) =>
                                    storedTopic !== topic.unparsedName,
                                );
                              setEnabledNotificationTopics(
                                updatedEnabledNotificationTopics,
                              );
                              setDisabledNotificationTopics([
                                ...disabledNotificationTopics,
                                topic.unparsedName,
                              ]);
                              await unsubscribeTokenFromTopic(
                                null,
                                topic.unparsedName,
                              );
                            } else {
                              setEnabledNotificationTopics([
                                ...enabledNotificationTopics,
                                topic.unparsedName,
                              ]);
                              setDisabledNotificationTopics(
                                disabledNotificationTopics.filter(
                                  (storedTopic) =>
                                    storedTopic !== topic.unparsedName,
                                ),
                              );
                              await subscribeTokenToTopic(
                                null,
                                topic.unparsedName,
                              );
                            }
                          }}
                          aria-readonly
                        />
                      </TableCell>
                    </TableRow>
                  ),
              )}
          </TableBody>
        </Table>
      </ScrollArea>
    </CredenzaContent>
  );
}

export async function getServerSideProps(context: any) {
  return {
    props: {
      messages: (await import(`@/public/i18n/${context.locale}.json`)).default,
    },
  };
}
